import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { Invoice } from '../../data/types';

export type CaseInvoiceState = {
    invoices: Invoice[],
}

export const useCaseInvoiceState = () => {
    const invoiceState = useSelector((state: RootState | any) => state.caseInvoices as CaseInvoiceState);
    return invoiceState;
}

// Define the initial state using that type
const initialState: CaseInvoiceState = {
    invoices: [],
}

export const caseInvoiceSlice = createSlice({
    name: 'caseInvoices',
    initialState: initialState,
    reducers: {
        setCaseInvoicesAction: (state, action: PayloadAction<Invoice[]>) => {
            state.invoices = action.payload;
        },
        addOrReplaceCaseInvoiceAction: (state, action: PayloadAction<Invoice>) => {
            const existingIndex = state.invoices.findIndex((invoice: Invoice) => invoice?.invoiceId === action.payload.invoiceId);
            if (existingIndex >= 0) {
                state.invoices[existingIndex] = action.payload;
            } else {
                state.invoices.push(action.payload);
            }
        },
        deleteCaseInvoiceAction: (state, action: PayloadAction<string>) => {
            state.invoices = state.invoices.filter((x) => x.invoiceId !== action.payload);
        },
        deleteCaseInvoicesAction: (state, action: PayloadAction<string[]>) => {
            state.invoices = state.invoices.filter((x) => x.invoiceId && !action.payload.includes(x.invoiceId));
        },
    }
})

export const { addOrReplaceCaseInvoiceAction, setCaseInvoicesAction, deleteCaseInvoiceAction, deleteCaseInvoicesAction } = caseInvoiceSlice.actions;
export default caseInvoiceSlice.reducer;